import React from "react";
import { ConfigProvider } from "antd";
import { CarSelectPage } from "../pages/CarSelect/CarSelectPage";
import "../App.css";

function App() {
  return (
    <ConfigProvider>
      <CarSelectPage />
    </ConfigProvider>
  );
}

export default App;
